import styled from "styled-components";
import { Flex } from "antd";
import Text from "../text";
import React from "react";

const Styled = styled.div`
  gap: 1rem;
  display: flex;
  flex-direction: column;
  .dot {
    width: 0.8rem;
    height: 0.8rem;
    flex-shrink: 0;
    margin-top: 0.4rem;
    border-radius: 50%;
    background-color: ${(_) => _.theme.token.fontColors[_.bulletType]};
  }
`;

const OrderList = ({
  items = [],
  prefix = "number",
  textType = "secondary",
  bulletType = "primary",
  ...props
}) => {
  return (
    <Styled
      {...props}
      bulletType={bulletType}
      children={React.Children.toArray(
        items.map((item, index) => (
          <Flex gap={".7rem"}>
            {prefix === "bullet" ? (
              <div className="dot" />
            ) : (
              <Text type={textType} children={index + 1 + "."} />
            )}
            <li
              children={
                <Text
                  weight={"500"}
                  type={textType}
                  lineHeight="1.6rem"
                  {...(typeof item === "object" && !Array.isArray(item)
                    ? item
                    : { children: item })}
                />
              }
            />
          </Flex>
        ))
      )}
    />
  );
};

export default OrderList;
